import "./App.css";

export default function Footer() {
  return (
    <div className="footer">
      Coded by{" "}
      <a
        href="https://github.com/arinapolianker"
        target="_blank"
        rel="noreferrer"
      >
        Arina Polianker
      </a>
      , and an open source on{" "}
      <a
        href="https://github.com/arinapolianker/dictionary-app"
        target="_blank"
        rel="noreferrer"
      >
        GitHub
      </a>
    </div>
  );
}
